import { useCallback, useMemo, useState } from 'react';
import {
  CartLine,
  addLine,
  cartItemCount,
  cartTotal,
  setLineQuantity,
} from '@/lib/ordering/cart';
import { trackOrderingEvent } from '@/lib/ordering/analytics';

/** Carrito en memoria del menú público. No persiste pedidos ni datos personales. */
export function useMenuCart() {
  const [lines, setLines] = useState<CartLine[]>([]);

  const add = useCallback((incoming: Omit<CartLine, 'lineId'>) => {
    setLines((current) => addLine(current, incoming));
    trackOrderingEvent('add_to_cart', { quantity: incoming.quantity });
  }, []);

  const setQuantity = useCallback((lineId: string, quantity: number) => {
    setLines((current) => setLineQuantity(current, lineId, quantity));
  }, []);

  const remove = useCallback((lineId: string) => {
    setLines((current) => current.filter((line) => line.lineId !== lineId));
  }, []);

  const clear = useCallback(() => setLines([]), []);

  const total = useMemo(() => cartTotal(lines), [lines]);
  const count = useMemo(() => cartItemCount(lines), [lines]);

  return { lines, add, setQuantity, remove, clear, total, count };
}
